export enum SupportedLanguage {
  FR = 'French',
  EN = 'English',
}
